Order            = require 'models/order'
{ timedPromise } = require 'utils/rsvp'
PromiseQueue     = require 'utils/promise-queue'
RecalculateModalBodyMixin     = require 'mixins/recalculate-modal-body'

ORDER_STATUSES  = Order.STATUSES
PAYMENT_METHODS = Order.PAYMENT_METHODS

FIELD_TYPE_DEBOUNCE = 300

module.exports = App.OrderModalComponent = Em.Component.extend RecalculateModalBodyMixin,
  # ----
  # Сервисы
  # ----
  session: Em.inject.service()
  env:     Em.inject.service('environment')
  store:   Em.inject.service('store')
  yandexMapsService: Em.inject.service('yandexMaps')
  dadataService:     Em.inject.service('dadata')

  openedOrdersBinding: 'session.openedOrders'

  restaurantTables: []

  takeaways: (->
    @get('organization.delivery_zones').filter((el)->
      el.get('takeaway') && el.get('restaurant.is_running')
    ).sort((a,b) ->
      return -1 if a.get('restaurant.city') < b.get('restaurant.city')
      return 1 if a.get('restaurant.city') > b.get('restaurant.city')
      return -1 if a.get('restaurant.name') < b.get('restaurant.name')
      return 1 if a.get('restaurant.name') > b.get('restaurant.name')
      return 0
    )
  ).property('organization.delivery_zones')

  selectedDeliveryZone: (->
    return @get('order.delivery_zone.name') unless @get('order.takeaway')
    "#{@get('order.delivery_zone.restaurant.city')}, #{@get('order.delivery_zone.restaurant.name')}"
  ).property('order.delivery_zone', 'order.takeaway')

  selectedTableName: (->
    return @get('order.table.name')
  ).property('order.table')

  setRestaurantTables: (->
    @get('store').find('table', restaurant_id: @get('order.restaurant.id')).then (tables) =>
      @set('restaurantTables', tables)
  ).observes('order.delivery_zone', 'order.restaurant').on('init')


  canDeleteOrder: (->
    @get('session.accessRights.orderDelete') || @get('order.status') == 'draft'
  ).property('order.status', 'session.accessRights.orderDelete')

  canEditOrder: (->
    @get('session.accessRights.orderEdit') && (
      !@get('order.organization.features.restrict_order_update_after_delivery') ||
      @get('order.status') != 'complete' ||
      @get('session.currentUser.account.isAdmin') || @get('session.currentUser.account.isRegionalAdmin')
    )
  ).property(
    'session.accessRights.orderEdit',
    'order.status',
    'session.currentUser.account.isAdmin',
    'session.currentUser.account.isRegionalAdmin'
  )

  editButtonText: (->
    if @get('isEditingFields')
      @get('env').translate('order.edit.finish_editing')
    else
      @get('env').translate('order.edit.edit_order')
  ).property('isEditingFields')
  
  showCopyPaymentLinkButton: (->
    @get('order.payment_pay_url') and not @get('order.payment_success')
  ).property('order.payment_pay_url', 'order.payment_success')

  copyPaymentLinkButtonContent: (->
    if @get('showCopyPaymentLinkButton')
      return 'https:' + @get('order.payment_pay_url')
  ).property('showCopyPaymentLinkButton')

  validateOrder: ->
    order = @get('order')

    if order.get('isDraft')
      order.validate()
      .then (result) =>
        @set('validations', result.validations)
    else
      @set('validations', [])
      Em.RSVP.resolve(null)

  resetState: (->
    # Сбрасываем состояние клиента
    client = @get('order.client.content')
    if client
      @set('clientState', 'present')
    else
      @set('clientState', 'empty')

    @set('syncState', 'empty')

    # Черновый заказы всегда по-умолчанию редактируются
    if @get('session.accessRights.orderEdit')
      @set('isEditingFields', @get('order.isDraft'))

    @validateOrder()
  ).on('didInsertElement')

  # ---
  # Список городов для автодополнения поля city
  # ---
  cities: Ember.computed 'restaurants', ->
    cities = []

    @get('restaurants').forEach((item) ->
      city = item.get 'city'

      if !Ember.isEmpty(city)
        cities.push city
    )

    cities.uniq().sort()

  # ---
  # Кто сейчас смотрит этот заказ
  # ---

  order_now_viewing: (->
    return false if Ember.isEmpty(@get('openedOrders')) || Ember.isEmpty(viewers = @get('openedOrders')[@get('order.id')])
    Object.keys(viewers).map((v) => viewers[v].user_name).join(', ')

  ).property('openedOrders','session.openedOrdersCount')


  # ---
  # Какой сервис использовать для подсказки адреса
  # ---
  addressProvider: (->
    return 'google' if @get('order.organization.features.use_google_in_board')
    'dadata'
  ).property('order.organization')

  # ---
  # Имя и телефон
  # ---
  phoneValue: (-> 
    phone = @get('order.contact_phone')
    return '' unless phone
    return if phone.startsWith('+') then phone else "+#{phone}"
  ).property('order.contact_phone')

  # ---
  # Выбор статуса
  # ---
  orderStatuses: []
  initSelectValues: (->
    @set('orderStatuses', ORDER_STATUSES.map (status) =>
      {
        value: status,
        text: @get('env').translate("order.status.#{status}")
      })

  ).on('init')

  orderPaymentMethods: (->
    methods = PAYMENT_METHODS

    if @get('order.organization.features.filter_board_payment_methods')
      methods = []
      methods.push 'courier_card' if @get('organization.accept_courier_card')
      methods.push 'card' if @get('organization.accept_cashless')
      methods.push 'cash' if @get('organization.accept_cash')

    methods.map (method) =>
      {
        value: method,
        text: @get('env').translate("order.payment_method.#{method}")
      }
  ).property('order.organization')

  orderStatusName: (->
    @get('env').translate("order.status.#{ @get('order.status') }")
  ).property('order.status')

  # ---
  # Редактирование клиента
  # ---
  # present, empty, loading, empty
  clientState: 'present'
  isClientLoading: Em.computed.equal('clientState', 'loading')
  isClientPresent: Em.computed.equal('clientState', 'present')
  isClientEmpty:   Em.computed.equal('clientState', 'empty')
  askForTimeUpdate: false
  placeStatus: null

  paymentBy: (->
    @get('env').translate("order.payment_method.#{@get('order.payment_source')}")
  ).property('order.payment_source')

  deliveryTypeText: (->
    @get('env').translate("order.delivery_type.#{@get('order.deliveryType')}")
  ).property('order.takeaway', 'order.dine_in')

  asapTypeText: (->
    if @get('order.delivery_asap')
      @get('env').translate("order.asap_type.asap")
    else
      @get('env').translate("order.asap_type.specified_time")
  ).property('order.delivery_asap')
  # ---
  # Печать выписки
  # ---
  printReceiptIsLoading: false

  # ---
  # Геолокация
  # ---
  isGeocodeLoading: false

  showChangeResetButton: (->
    @get('order.organization.features.require_change') && @get('order.change') != '' && @get('order.change') != null
  ).property('order.organization.features.require_change', 'order.change')

  showCutleryEdit: (->
    @get('order.organization.features.max_cutlery') && @get('order.isDraft')
  ).property('order.organization.features.max_cutlery', 'order.isDraft')

  orderTags: (->
    @get('env.features.orderTags')
  ).property('env.features.orderTags')

  staffCommentEnabled: (->
    @get('env.features.orderStaffCommentEnabled')
  ).property('env.features.orderStaffCommentEnabled')

  deliveryPriceEdit: Em.computed.oneWay('order.delivery_price')

  showOrderAddressMap: (->
    @get('order.restaurant.content') and (@get('env.features.boardShowOrderAddressMap') or @get('order.organization.features.board_show_order_address_map'))
  ).property('order.restaurant')

  # ---
  # Геокодит заказ и заполняет все поля
  # ---

  delay: (time, v) ->
    new Em.RSVP.Promise (resolve, reject) =>
      setTimeout(resolve.bind(null, v), time)

  geocodeOrder: ->
    order = @get('order')
    (
      if @get('addressProvider') == 'dadata'
        @get('dadataService').getSuggestions(order.get('address'))
        .then (res) =>
          filterSuggestions = res.suggestions.filter (el) => not el.house_number_error
          firstObject = filterSuggestions[0]
          if firstObject
            order.setProperties({
              block: firstObject.block,
              house: firstObject.house,
              street: firstObject.street,
              street_type: firstObject.street_type,
              houseNumberError: not firstObject.house,
              coordinates: "POINT (#{firstObject.lon} #{firstObject.lat})"
            })
          order.save()
      if @get('addressProvider') == 'yandex'
        @get('yandexMapsService').retrieve()
        .then (ymaps) =>
          ymaps.geocode(order.get('address'))
          .then (res) =>
            firstObject = res.geoObjects.getIterator()?.getNext()
            kind = firstObject?.properties?._data?.metaDataProperty?.GeocoderMetaData?.kind
            if firstObject
              coords = firstObject.geometry.getCoordinates()
              order.set 'coordinates', "POINT (#{coords[1]} #{coords[0]})"
              order.set 'houseNumberError', (kind != 'house')
            order.save()
      else
        # TODO Надо будет аналогично и для гугла сделать вот тут
        order.save()
        .then =>
          order.geocode()
    )
    .then =>
      # order.geocode()
      # .then =>
      order.assignZone()
    .then =>
      order.reload()
    .then =>
      order.get('delivery_zone')
    .then (zone) =>
      return Em.RSVP.resolve() unless zone
      zone.get('restaurant')
    .then (restaurant) =>
      { price, delivery_time, cooking_time, transportation_time } = order.get('delivery_zone')
        .getProperties('price', 'delivery_time')

      order.set('restaurant', restaurant)
      order.setProperties({ delivery_price: price, delivery_time, cooking_time, transportation_time })
      @saveAndValidate()

    .catch =>
      false

  reloadOrder: ->
    order = @get('order')

    @set('syncState', 'syncing')

    order.reload()
    .then =>
      # order.get('items').reload()
      order.get('buddies').reload()
      @validateOrder()
    .then =>
      @set('syncedAt', new Date)
      @set('syncState', 'synced')
    .catch =>
      @set('syncState', 'error')

  # ---
  # Сохраняет заказ и валидирует его через корзину
  # ---
  saveAndValidate: ->
    order = @get('order')

    @set('syncState', 'syncing')

    order.save()
    .then =>
      @validateOrder()
    .then =>
      @set('syncedAt', new Date)
      @set('syncState', 'synced')
    .catch =>
      @set('syncState', 'error')

  # ---
  # Найти пользователя по телефону
  # ---
  fillClient: ->
    number = @get('order.contact_phone')
    return Em.RSVP.reject('Wrong number') unless number

    @set('clientState', 'loading')

    Em.RSVP.allSettled([
      @get('store').find('client', {
        # organization_id: @get('organization.id'),
        phone_number: number
      })
      timedPromise(500)
    ])
    .then (result) =>
      clients = result[0].value
      if clients.get('length') <= 0
        @set('clientState', 'empty')
        @set('order.client', null)

        return Em.RSVP.reject('No client found')

      client = clients.get('firstObject')
      @get('order').setProperties({
        client,
        contact_name:  client.get('name')
        contact_phone: number
      })

      Em.RSVP.hash
        client: Em.RSVP.resolve(client)
        save:   @saveAndValidate()
    .then (params) =>
      Em.RSVP.hash
        client:  Em.RSVP.resolve(params.client)
        buddies: @get('order').get('buddies')
    .then (params) =>
      { client, buddies } = params

      owners = buddies.filter (b) =>
        b.get('is_owner')

      if owners.get('length') <= 0
        return Em.RSVP.resolve()

      owner = owners.get('firstObject')
      owner.setProperties
        name:  client.get('name')
        avatar: client.get('avatar')

      @set('clientState', 'present')
      owner.save()
    .catch => false

  # ---
  # Редактирование заказа сихронизация
  # ---
  isEditingFields: false
  fieldsDisabled:  Em.computed.not('isEditingFields')
  statusSelectDisabled: Em.computed.or('fieldsDisabled', 'order.isDraft')
  zoneSelectDisabled:   Em.computed.or('fieldsDisabled', 'notTakeaway')

  showDraftStatusNotice: (->
    @get('isEditingFields') and @get('order.isDraft')
  ).property('isEditingFields', 'order.isDraft')

  notTakeaway: Em.computed.not('order.takeaway')

  syncState: 'empty'
  syncedAt: null
  isSyncEmpty:   Em.computed.equal 'syncState', 'empty'
  isSyncError:   Em.computed.equal 'syncState', 'error'
  isSyncSyncing: Em.computed.equal 'syncState', 'syncing'
  isSyncSynced:  Em.computed.equal 'syncState', 'synced'

  syncStateText: (->
    state = @get('syncState')
    syncedAt = @get('syncedAt')
    env = @get('env')

    return '' if state is 'empty'
    return env.translate("order.edit.sync.#{state}",
      when: moment(syncedAt).format('HH:mm'))
  ).property('syncState', 'syncedAt')

  # Для поддержки debounce
  _fieldChanged: -> @send 'syncOrder'

  initPromiseQueue: (->
    @set('promiseQueue', PromiseQueue.create())
  ).on('init')

  # ---
  # Валидации заказа
  # ---
  validations: []

  cantPlaceOrder: (->
    return false unless @get('validations')

    vld = @get('validations').filter (v) =>
      not (v.type is 'info')
    .length > 0
  ).property('validations.@each.type')

  # ---
  # Статус
  # ---
  statusName : (->
    @get('env').translate( "order.status.#{ @get('order.status') }" )
  ).property('order.status')

  isLabelPrinterEnabled:      (->
    @get('order.organization.features.label_printer')
  ).property()

  integrationLogLink: (->
    return null unless @get('order.integration_params')
    order = @get('order')
    params = @get('order.integration_params')

    pos = ['iiko','poster','carbis','frontpad', 'iiko_transport', 'procart', 'rk_delivery'].find (v) -> params.hasOwnProperty v
    return null unless pos

    # TODO: Логи новых интеграций с pos-системами расположены на вложенном неймспейсе в board2.
    # Убрать проверку после перевода всех интеграций на services.
    if ['procart', 'rk_delivery'].includes(pos)
      return "//smartomato.ru/board2/integration/pos/#{pos}/log/?order_id=#{order.id}"

    "//smartomato.ru/board2/integration/#{pos}/log/?order_id=#{order.id}"
  ).property('order.integration_params')

  bonusAmount: (->
    return null unless @get('order.client.bonus') or !@get('order.organization.features.bonus_enabled')
    bonusLimit = @get('order.organization.features.bonus_limit_percent_in_order')
    bonusAmount = @get('order.client.bonus.amount')
    orderTotal = @get('order.total')
    maxAmount = Math.floor (orderTotal * bonusLimit) / 100
    return if bonusAmount >= maxAmount then maxAmount else Math.floor bonusAmount
  ).property('order.client.bonus', 'order.total')

  # ---
  # Доступные поля для фильтрации истории изменений
  # ---
  allowedFieldsHistory: (->
    return ['status'] unless @get('fullHistory')
    ['status', 'pick_up_at', 'cooking_start_at', 'delivery_at', 'courier_id', 'contact_phone', 'contact_name']
  ).property('fullHistory')

  fullHistory: false

  actions:
    resetChange: ->
      order = @get('order')
      order.set('change', null)
      @send('fieldChanged')

    moreHistory: ->
      @set('fullHistory', !@get('fullHistory'))

    deliveryPriceChanged: ->
      order = @get('order')
      price = parseInt @get('deliveryPriceEdit')

      if !Number.isNaN(price) && price != order.get('delivery_price')
        order.set('delivery_price', price)
        @send('fieldChanged')

      @set('deliveryPriceEdit', order.get('delivery_price'))

      false

    contentChanged: ->
      @get('promiseQueue').push('sync', @reloadOrder.bind(@))
      false

    syncOrder: ->
      @get('promiseQueue').push('sync', @saveAndValidate.bind(@))
      false


    deliveryAsapChanged: ->
      order = @get('order')

      if not order.get('delivery_asap') and not order.get('delivery_at')
        delivery_at = moment().toDate()
        order.set('delivery_at', delivery_at)

      @send('fieldChangedImmediate')
      false

    closeModal: ->
      @sendAction 'onCloseModal'
      false

    transitionToClient: (client) ->
      if @get('session.accessRights.clients')
        @sendAction('onTransition', 'clients.client', client)
      false

    toggleEditOrder: ->
      @toggleProperty('isEditingFields')
      false

    updateClientByNumber: (number) ->
      @get('order').set('contact_phone', number)
      @get('promiseQueue').push('client', @fillClient.bind(@))
      false

    geocodeOrder: ->
      return if @get('isGeocodeLoading')

      @set('isGeocodeLoading', true)
      @get('promiseQueue').push 'geocode', =>
        @geocodeOrder()
        .finally => @set('isGeocodeLoading', false)
      false

    fieldChangedDeliveryAt: ->
      if @get('order.status') != 'draft' && @get('order.delivery_asap') == false
        @set('askForTimeUpdate',true)

      @send 'fieldChanged'
      false

    fieldChanged: ->
      Em.run.debounce @, @_fieldChanged, FIELD_TYPE_DEBOUNCE
      false

    fieldChangedImmediate: ->
      @send 'syncOrder'
      false

    fieldChangedreloadOrder: ->
      @send('syncOrder')
      @send('contentChanged')
      false

    openIntegrationLog: ->
      window.open(@get('integrationLogLink'), '_blank')

    printLabels: ->
      order = @get('order')

      iframe = Em.$('<iframe src="//smartomato.ru/board2/orders/'+order.id+'?without_nav=1" class=labelPrint>')
      .appendTo(Em.$('body'))
      .get(0)

      Em.$(iframe).click (e) ->
        $(@).remove()


    printReceipt: ->
      order = @get('order')
      @set('printReceiptIsLoading', true)

      order.receipt()
      .then (data) =>
        iframe = Em.$('<iframe>')
        .css(width: 0, height: 0)
        .appendTo(Em.$('body'))
        .get(0)

        new Em.RSVP.Promise (resolve, reject) =>
          iframe.srcdoc = data
          iframe.onload = ->
            iframe.contentWindow.print()
            resolve()
      .finally =>
        @set('printReceiptIsLoading', false)
      false

    deleteOrder: ->
      return unless confirm(Em.I18n.t 'order.edit.delete_confirm')
      order = @get('order')
      order.destroyRecord()
      .then =>
        @sendAction('onRemoveOrder', order)
        @send('closeModal')
      false

    handleZoneSelect: (zone) ->
      order = @get('order')

      @get('promiseQueue').push 'sync', =>
        zone.get('restaurant')
        .then =>
          order.set('delivery_zone', zone)
          order.set('restaurant', zone.get('restaurant'))

          if order.get('takeaway')
            order.set('delivery_price', 0)
          else
            order.set('delivery_price', zone.get('price'))
          @saveAndValidate()

    placeOrder: ->
      @set('isPlaceLoading', true)
      order = @get('order')

      @get('promiseQueue').push 'place', =>
        # todo i18n
        @set('placeStatus', 'Сохраняем заказ')
        order.save()
        .then =>
          # todo i18n
          @set('placeStatus', 'Проверяем заказ')
          @validateOrder()
        .then =>
          unless @get('cantPlaceOrder')
            # todo i18n
            @set('placeStatus', 'Размещаем заказ')
            order.place()
          else
            @set('placeStatus', null)
            @set('isPlaceLoading', false)
            new Em.RSVP.Promise (resolve, reject) => reject()
        .then =>
          order.reload()
        .then =>
          @sendAction('onTransition', 'orders.list')
        .finally =>
          @set('placeStatus', null)
          @set('isPlaceLoading', false)
      false

    doTimeUpdate: ->
      ct = @get('order.delivery_zone.cooking_time')
      dt = @get('order.delivery_zone.transportation_time')
      takeaway = @get('order.takeaway')

      if ct && (dt || takeaway)
        if takeaway
          @set 'order.pick_up_at', @get('order.delivery_at')
        else
          @set('order.pick_up_at', moment(@get('order.delivery_at')).subtract(dt, 'minutes').toDate())
        @set('order.cooking_start_at', moment(@get('order.pick_up_at')).subtract(ct, 'minutes').toDate())
        @get('order').save()

      @set('askForTimeUpdate',false)

    setOrderAddress: (address) ->
      # todo i18n
      if confirm("Заменить адрес на #{ address.get('address') }?")
        @set 'order.address',  address.get('address')

        @set 'order.staircase',  address.get('staircase')
        @set 'order.apartment',  address.get('apartment')
        @set 'order.floor',  address.get('floor')
        @set 'order.doorphone',  address.get('doorphone')
        @set 'order.address_comment',  address.get('address_comment')

        @send('geocodeOrder')
      false

    openPopup: (type) ->
      @get('miniPopups').send('openPopup', type)
      false

    closePopup: ->
      @set('currentPopupOpened', '')
      false

    copyPaymentLink: ->
      textToCopy = $('.copy-payment-button').data('clipboard-text')
      alertText = Em.I18n.t 'promo_card.condition.copied'

      if textToCopy
        if navigator.clipboard?
          navigator.clipboard.writeText(textToCopy)
            .then ->
              alert alertText
            .catch (err) ->
              console.error 'Error in copying text: ', err
        else
          $input_field = $('<textarea>')
          $input_field.val(textToCopy)
          $('body').append($input_field)
          $input_field.select()

          try
            successful = document.execCommand('copy')
            if successful
              alert alertText
          catch err

          $input_field.remove()
